import * as Yup from 'yup';
import { TargetConfigMetaData } from '../models';
import Zendesk from './index';

export const ZENDESK_CONFIG: TargetConfigMetaData = {
  formComponent: Zendesk,

  initialValues: {
    subDomain: '',
    email: '',
    token: ''
  },

  validationSchema: Yup.object({
    subDomain: Yup.string().trim().required(),
    email: Yup.string().trim().required(),
    token: Yup.string().trim().required()
  }),

  fieldNameMapping: {
    subDomain: 'sub-domain',
    email: 'email',
    token: 'token'
  }
};
